interface FetchWithBackoffOptions {
    maxRetries?: number;
    initialDelayMs?: number;
    timeoutMs?: number;
}

/**
 * Executa uma requisição assíncrona com Exponential Backoff e Timeout.
 * Aborta a requisição se exceder timeoutMs. Tenta novamente em caso de 503 ou 429.
 */
export async function executeWithResilience<T>(
    apiCall: (signal: AbortSignal) => Promise<T>,
    options: FetchWithBackoffOptions = {}
): Promise<T> {
    const maxRetries = options.maxRetries ?? 3;
    let delay = options.initialDelayMs ?? 1000;
    const timeoutMs = options.timeoutMs ?? 20000;

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

        try {
            const result = await apiCall(controller.signal);
            clearTimeout(timeoutId);
            return result;

        } catch (error: any) {
            clearTimeout(timeoutId);

            const isOverloaded = error?.status === 503 || error?.code === 503 || error?.status === 429;
            const isTimeout = error?.name === 'AbortError';

            if ((isOverloaded || isTimeout) && attempt < maxRetries) {
                console.warn(`[AuteurDraft] API sobrecarregada/timeout (Tentativa ${attempt}/${maxRetries}). Retentando em ${delay}ms...`);
                await new Promise(resolve => setTimeout(resolve, delay));
                delay *= 2;
                continue;
            }

            console.error(`[AuteurDraft] Falha crítica na IA após ${attempt} tentativas.`, error);
            throw error;
        }
    }

    throw new Error("Falha na execução após múltiplas tentativas.");
}
